var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41092",
    "data-name": "Group 41092",
    transform: "translate(9889 850)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14917",
    "data-name": "Rectangle 14917",
    width: 20,
    height: 20,
    transform: "translate(-9889 -850)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat_2_",
    "data-name": "chat (2)",
    transform: "translate(-9887.749 -848.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36721",
    "data-name": "Path 36721",
    d: "M4.17,11.348A7.186,7.186,0,0,1,11.348,4.17h.129a.342.342,0,0,0,.317-.479A6.153,6.153,0,1,0,1.568,10.255a1.025,1.025,0,0,0-.981,1.021A1.047,1.047,0,0,0,1.635,12.3H3.854a.342.342,0,0,0,.34-.371Q4.17,11.642,4.17,11.348Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36722",
    "data-name": "Path 36722",
    d: "M162.737,162.255a6.152,6.152,0,1,0-5.268,2.012v.038h5.224a1.025,1.025,0,0,0,.044-2.05Zm-7.319-3.419a.684.684,0,1,1,.684-.684A.684.684,0,0,1,155.418,158.836Zm2.734,0a.684.684,0,1,1,.684-.684A.684.684,0,0,1,158.152,158.836Zm2.734,0a.684.684,0,1,1,.684-.684A.684.684,0,0,1,160.887,158.836Z",
    transform: "translate(-146.805 -146.805)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0cffe786f7c92132188bfcda0f442cb4.svg";
export { ForwardRef as ReactComponent };